export const exly_connect_apis = {
  inform_meeting_joined: "/exlycon/update/meeting",
  fetch_meeting_details_for_host: "/exlycon/start/host/meeting",
  fetch_meeting_details_for_customer: "/exlycon/join/customer/meeting",
  host_redirect_old_flow: "/host/redirect/old/flow",
};

export const auth_apis = {
  fetch_auth_token: "/users/auth/token",
};

export const api_status = {
  NOT_ACCEPTABLE: 406,
};

export const http_methods = {
  get: "GET",
  post: "POST",
};

export const redirect_old_flow_header = {
  key: "REDIRECT-TO-OLD",
  value: "1",
};

export const redirect_old_flow_query_params = {
  listing_uuid: "listing_uuid",
};
